import * as React from 'react'

export type Theme = 'dark' | 'light'
export type ThemePreference = 'dark' | 'light' | 'auto'

export interface ThemeContextValue {
  theme: Theme
  preference: ThemePreference
  setPreference: (pref: ThemePreference) => void
  toggleTheme: () => void
}

export const ThemeContext = React.createContext<ThemeContextValue>({
  theme: 'dark',
  preference: 'dark',
  setPreference: () => {},
  toggleTheme: () => {},
})
